var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-upload-place"},[_c('p',{staticClass:"upload-remark"},[_vm._v(" "+_vm._s(_vm.uploadTip)+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imitate-upload"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('i',{staticClass:"iconfont-v3 saasline-plus"})])])
}]

export { render, staticRenderFns }